export const nav = {
  men: {
    en: "MEN",
    cn: "男裝",
    jpn: "メンズウェア",
  },
  women: {
    en: "WOMEN",
    cn: "女裝",
    jpn: "婦人服",
  },
  kid: {
    en: "KIDS",
    cn: "童裝",
    jpn: "キッズウェア",
  },
  sale: {
    en: "SALE",
    cn: "SALE",
    jpn: "SALE",
  },
  new: {
    en: "NEW ARRIVALS",
    cn: "新產品",
    jpn: "新製品",
  },
  cart: {
    en: "Cart",
    cn: "購物車",
    jpn: "ショッピングカート",
  },
  profile: {
    en: "Profile",
    cn: "用戶資料",
    jpn: "ユーザープロファイル",
  },
  yourorder: {
    en: "Your Orders",
    cn: "您的訂單",
    jpn: "ご注文",
  },
  logout: {
    en: "Logout",
    cn: "登出",
    jpn: "ログアウト",
  },
  signin: {
    en: "Sign In",
    cn: "登入",
    jpn: "ログイン",
  },
  user: {
    en: "Users",
    cn: "所有用戶",
    jpn: "全てユーザー",
  },
  product: {
    en: "Products",
    cn: "所有產品",
    jpn: "全て製品",
  },
  order: {
    en: "Orders",
    cn: "所有訂單",
    jpn: "すべての注文",
  },
};
